import * as React from "react";
import { connect } from "react-redux";
import styled, { keyframes } from "styled-components";

import { RootState } from "../../state";
import ImageComponent, { Image } from "../../common/components/Image";
import { draftCompanySelector } from "../selectors";

interface MappedProps {
  avatar?: Image | null;
}

type Props = MappedProps;

class CompanySpinnerContainer extends React.PureComponent<Props> {
  public render() {
    const { avatar } = this.props;
    if (!avatar) {
      return null;
    }
    return (
      <Wrapper>
        <Avatar image={avatar} size="90x90m" lazy={false} />
      </Wrapper>
    );
  }
}

function mapStateToProps(state: RootState): MappedProps {
  const company = draftCompanySelector(state);
  return {
    avatar: company ? company.avatar : null,
  };
}

export default connect(mapStateToProps)(CompanySpinnerContainer);

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  display: flex;
  min-height: 500px;
  align-items: center;
  justify-content: center;
`;

const Avatar = styled(ImageComponent)`
  display: block;
  width: 60px;
  height: 60px;
  border: solid 3px rgba(224, 224, 224, 1);
  border-radius: 50px;
  animation: ${rotate360} 1s ease infinite;
`;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/CompanySpinnerContainer.tsx